export enum StepsTourEnum {
  menuBootstrapStep = 0,
  headerStep = 1,
}
